'use client'
import React from 'react'
import { Line } from 'react-chartjs-2'
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);

export default function LineChartDefault(props) {
  const { data, categories, index, className="" } = props
  const highestNumber = Math.max(...data.map(item => item.price))
  const lowestNumber = Math.min(...data.map(item => item.price))
  
  const labels = data.map(item => item.date)
  const data_ = data.map(item => item.price)
  const data_ma_50 = data.map(item => item.ma_50)
  const data_ma_200 = data.map(item => item.ma_200)
  const data_ema_50 = data.map(item => item.ema_50)
  const data_ema_200 = data.map(item => item.ema_200)
  
  return (
    <div className={className}>
      <Line
        height={400}
        datasetIdKey='id'
        data={{
          labels: labels,
          datasets: [
            {
              id: 1,
              label: 'Price',
              data: data_,
              tension: 0.4,
            },
          ],
        }}
        options={{
          plugins: {
            legend: {
              // display: false,
            },
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            y: {
              suggestedMin: lowestNumber,
              suggestedMax: highestNumber,
              grid: {
                display: true,
                color: 'rgba(0, 0, 0, 0.05)',
              },
            },
            x: {
              grid: {
                display: false,
              },
            }
          },
        }}
      />
    </div>
  )
}
